export default __webpack_public_path__ + "static/media/error_outline.03f36bf7.svg";